type RouteCellProps = {
  routeName: string
  aggregatorName: string
}

const RouteCell = ({routeName, aggregatorName}: RouteCellProps) => {
  return (
    <>
      <span className='d-block'>{routeName}</span>
      <span className='badge badge-light-info'>{aggregatorName}</span>
    </>
  )
}

export default RouteCell
